import PropTypes from "prop-types";
import { useState } from "react";

import CardShell, { BackToSignIn } from "./card_shell";
import { TextField } from "./fields";
import { FlashBanner } from "./status_messages";

const PasswordRequestPage = ({
  flash,
  paths,
  authenticityToken,
  initialEmail,
  resetPasswordSent,
  requestTitle = "Set or reset your password",
  passwordRequestTooltipTitle = "Set or reset your password",
  passwordRequestTooltipBody = "We'll email you a one-time link to set or reset your password. Use this whether you've never set a password (because you usually sign in with Google or Microsoft) or you've forgotten your existing one.",
}) => {
  const [email, setEmail] = useState(initialEmail || "");

  if (resetPasswordSent) {
    return (
      <CardShell>
        <div className="text-center">
          <h1 className="auth-subtitle">Set or reset your password</h1>
          <p className="auth-confirmation-copy">
            If your email is in our system, we&apos;ve sent you a link to set or
            reset your password. Check your inbox.
          </p>
          <BackToSignIn path={paths.signIn} />
        </div>
      </CardShell>
    );
  }

  return (
    <CardShell>
      <form action={paths.passwordRequest} method="post">
        <input
          type="hidden"
          name="authenticity_token"
          value={authenticityToken}
        />

        <h1 className="auth-subtitle text-center">{requestTitle}</h1>

        <TextField
          id="user_email"
          name="user[email]"
          label="Email address"
          placeholder="Email address"
          value={email}
          onChange={setEmail}
          autoComplete="email"
          tooltipTitle={passwordRequestTooltipTitle}
          tooltipBody={passwordRequestTooltipBody}
        />

        <button
          type="submit"
          className="btn btn-lg btn-block auth-primary-button"
        >
          Email me a link
        </button>
      </form>

      <div className="mt15">
        <FlashBanner flash={flash} />
      </div>

      <BackToSignIn path={paths.signIn} />
    </CardShell>
  );
};

PasswordRequestPage.propTypes = {
  flash: PropTypes.object,
  paths: PropTypes.shape({
    signIn: PropTypes.string.isRequired,
    passwordRequest: PropTypes.string.isRequired,
  }).isRequired,
  authenticityToken: PropTypes.string.isRequired,
  initialEmail: PropTypes.string,
  resetPasswordSent: PropTypes.bool,
  requestTitle: PropTypes.string,
  passwordRequestTooltipTitle: PropTypes.string,
  passwordRequestTooltipBody: PropTypes.string,
};

export default PasswordRequestPage;
